import React, { useState } from 'react';
import { connect } from 'react-redux';
import { clearFilterParams } from '../../actions/searchActions';
import { __ } from '../../helpers/TranslationService';
import { IHeader } from '../../interfaces/IHeader';
import { IStyles } from '../../interfaces/IStyles';
import { IState } from '../../reducers';
import { IAppConfig, IBrandConfig, IConfig } from '../../reducers/pageData';
import { ContactBlock } from '../HeaderDesktop/ContactBlock';
import { BackLink } from './BackLink';
import { BurgerButton } from './BurgerButton';
import { Favorites } from './Favorites';
import { Logo } from './Logo';
import { NavigationMenuContainer } from './NavigationMenuContainer';
import { Phone } from './Phone';

const styles: IStyles = {
    container: {
        padding: '12px 16px 12px 16px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: 'solid 2px #F5f5f5',
    },
    backLink: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 16px 0px 5px',
    },
    flexBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        lineHeight: 0,
    },
};

interface Props {
    header: IHeader;
    portalId: string;
    favoriteCount: number;
    favoritesUrl: string;
    phoneNumber: string;
    appConfig: IAppConfig;
    brandConfig: IBrandConfig;
    config: IConfig;
    hasReferrer: boolean;
}

type IProps = Props & typeof mapDispatchToProps;

export const HeaderClass = (props: IProps) => {
    const {
        clearFilterParams,
        portalId,
        header,
        config,
        brandConfig,
        appConfig,
        phoneNumber,
        favoritesUrl,
        favoriteCount,
        hasReferrer,
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const handleClickOpenMenu = () => setIsOpen(true);
    const handleClickCloseMenu = () => setIsOpen(false);

    let contactPagePath = `${config.contentEndpoint}${brandConfig.contactPagePath}`;

    const officeHours = header.headerContent ? header.headerContent.officeHours : null;

    const firstLine = officeHours?.firstLine?.length
        ? officeHours.firstLine
        : __('Mon - Fri: 8am - 6pm Sat: 9am - 3pm', 'dreamlines');
    const secondLine = officeHours?.secondLine?.length ? officeHours.secondLine : '';

    return (
        <>
            <div style={styles.container}>
                <Logo clearFilterParams={clearFilterParams} portalId={portalId} />
                <div style={styles.flexBox}>
                    {appConfig.countryCode !== 'br' && appConfig.countryCode !== 'it' && (
                        <>
                            <div className="mobile-hidden">
                                <ContactBlock
                                    phoneNumber={phoneNumber}
                                    contactPagePath={contactPagePath}
                                    firstLine={firstLine}
                                    secondLine={secondLine}
                                />
                            </div>
                            <div className="mobile-visible">
                                <Phone phoneNumber={phoneNumber} />
                            </div>
                        </>
                    )}
                    <Favorites count={favoriteCount} pageUrl={favoritesUrl} />
                    <BurgerButton onClick={handleClickOpenMenu} />
                </div>
                <NavigationMenuContainer
                    closeMenuClick={handleClickCloseMenu}
                    isOpen={isOpen}
                    mainNavigation={header.mainNavigationMobile}
                    exchangeRate={header.exchangeRate}
                    appConfig={appConfig}
                    brandConfig={brandConfig}
                    config={config}
                />
            </div>
            <div style={styles.backLink}>{hasReferrer && <BackLink />}</div>
        </>
    );
};

const mapDispatchToProps = {
    clearFilterParams,
};

const mapStateToProps = (state: IState) => ({
    header: state.pageData.header,
    portalId: state.pageData.brandConfig.portalId,
    appConfig: state.pageData.appConfig,
    brandConfig: state.pageData.brandConfig,
    config: state.pageData.config,
    favoriteCount: state.favoritePage.favorites.length,
    favoritesUrl: state.pageData.brandConfig.slugsObj.favorites,
    phoneNumber: state.pageData.brandConfig.phoneNumber,
    hasReferrer: state.pageData.hasReferrer,
});

export const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderClass);
